
cc.Class({
    extends: cc.Component,

    properties: {
        listeners: {
            type: cc.Component.EventHandler,
            default: []
        }
    },

    // TODO handle case when object changes its original position
    start () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');
        if (!this.resizeManager) {
            cc.warn('cannot find resize manager');
            return;
        }
        this.resizeManager.appendNode(this);
    },

    onDestroy () {
        if (this.resizeManager) {
            this.resizeManager.removeNode(this);
        }
    },

    onViewResize (screenRatio) {
        const screenRect = cc.view.getVisibleSize();
        const aspectRatio = screenRect.width / screenRect.height;

        this.listeners.forEach((listener) => {
            // eslint-disable-next-line no-underscore-dangle
            const component = listener.target.getComponent(listener._componentName);
            const handler = component[listener.handler];

            handler.call(component, screenRatio, aspectRatio, screenRect, listener.customEventData);
        });
    }
});
